import { render, staticRenderFns } from "./Intermediary.vue?vue&type=template&id=4985577e&scoped=true"
import script from "./Intermediary.vue?vue&type=script&lang=js"
export * from "./Intermediary.vue?vue&type=script&lang=js"
import style0 from "./Intermediary.vue?vue&type=style&index=0&id=4985577e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985577e",
  null
  
)

export default component.exports